import translations from '@/translations/translations.json'

export default {
  availableLanguages: {
    en_GB: 'English',
    ro_RO: 'Romanian'
  },
  // shouldn't defaultLanguage fallback to availableLanguages[0]?
  defaultLanguage: 'ro_RO',
  // languageVmMixin: {
  //   computed: {
  //     currentKebabCase: function () {
  //       return this.current.toLowerCase().replace('_', '-')
  //     },
  //   },
  // },
  // silent: true,
  translations: translations
}
